import React from 'react';
import { Redirect } from 'react-router-dom';

import Loadable from 'react-loadable';
import Loading from './components/Loading';
import Home from './containers/Home';
import Shopify from './containers/Shopify';
import NotFound from './containers/NotFound';

export default [
  {
    path: '/',
    exact: true,
    component: Home
  },
  {
    path: '/shopify',
    exact: true,
    component: Shopify
  },
  {
    path: '/not-found',
    exact: true,
    component: NotFound
  },
  {
    path: '/dashboard',
    exact: true,
    component: Loadable({ loader: () => import('./containers/Dashboard'), loading: Loading })
  },
  {
    path: '/campaign',
    exact: true,
    component: Loadable({ loader: () => import('./containers/Campaign/Campaigns'), loading: Loading })
  },
  {
    path: '/campaign/:link',
    exact: true,
    component: Loadable({ loader: () => import('./containers/Campaign'), loading: Loading })
  },
  {
    path: '/organization',
    exact: true,
    component: Loadable({ loader: () => import('./containers/Organization'), loading: Loading })
  },
  {
    path: '/insights',
    exact: true,
    component: Loadable({ loader: () => import('./containers/Insights'), loading: Loading })
  },
  {
    path: '/clients',
    exact: true,
    component: Loadable({ loader: () => import('./containers/Clients'), loading: Loading })
  },
  {
    path: '/users',
    exact: true,
    component: Loadable({ loader: () => import('./containers/Users'), loading: Loading })
  },
  {
    path: '/signup/:title?',
    exact: true,
    component: Loadable({ loader: () => import('./containers/Signup'), loading: Loading })
  },
  {
    path: '/plan',
    exact: true,
    component: Loadable({ loader: () => import('./containers/SignupStepSecond'), loading: Loading })
  },
  {
    path: '/mothersday',
    exact: true,
    component: Loadable({ loader: () => import('./containers/SpecialSignup'), loading: Loading })
  },
  {
    path: '/forgot/password',
    exact: true,
    component: Loadable({ loader: () => import('./containers/ForgotPassword'), loading: Loading })
  },
  {
    path: '/reset/password/:token',
    exact: true,
    component: Loadable({ loader: () => import('./containers/ResetPassword'), loading: Loading })
  },
  {
    path: '/videos',
    exact: true,
    component: Loadable({ loader: () => import('./containers/Videos'), loading: Loading })
  },
  {
    path: '/questions',
    exact: true,
    component: Loadable({ loader: () => import('./containers/Questions'), loading: Loading })
  },
  {
    path: '/videos/:uuid',
    exact: true,
    component: Loadable({ loader: () => import('./containers/Videos'), loading: Loading })
  },
  {
    path: '/campaign/videos/:filterId',
    exact: true,
    component: Loadable({ loader: () => import('./containers/Videos'), loading: Loading })
  },
  {
    path: '/plugin/:uuid',
    exact: true,
    component: Loadable({ loader: () => import('./containers/Plugin'), loading: Loading })
  },
  {
    path: '/billing',
    exact: true,
    component: Loadable({ loader: () => import('./containers/Billing'), loading: Loading })
  },
  {
    path: '/settings',
    exact: true,
    component: Loadable({ loader: () => import('./containers/Settings'), loading: Loading })
  },
  {
    path: '/change/password',
    exact: true,
    component: Loadable({ loader: () => import('./containers/ChangePassword'), loading: Loading })
  },
  {
    path: '/:id',
    exact: true,
    component: Loadable({ loader: () => import('./containers/Splash/Splash'), loading: Loading })
  },
  {
    path: '/view/:id',
    exact: true,
    component: Loadable({ loader: () => import('./containers/Splash/Splash'), loading: Loading })
  },
  {
    path: '/v/:fileName',
    exact: true,
    component: Loadable({ loader: () => import('./containers/Testimony'), loading: Loading })
  },
  {
    path: '*',
    exact: true,
    component: () => <Redirect to="/not-found" />
  },
];



// WEBPACK FOOTER //
// ./src/routes.js